import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";

const Block = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading font-bold text-2xl mb-2">{title}</h2>
    <div className="font-body text-charcoal/75 space-y-2">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <>
      <Seo path="/privacy" title="Privacy Policy" description="How Skedaddle Junk Removal collects and uses the information you share when requesting a quote." />
      <PageHero eyebrow="Legal" title="Privacy Policy" />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <p className="font-body text-charcoal/60 mb-8">Last updated June 2026.</p>
          <Block title="What we collect">
            <p>When you request a quote we collect your name, phone number, city, address, a description of what needs to go and any photos you choose to share. We use this only to prepare your quote and schedule your pickup.</p>
          </Block>
          <Block title="How we use it">
            <p>We use your information to contact you about your junk removal, provide a quote and complete the job. We do not sell your information to anyone.</p>
          </Block>
          <Block title="Text and phone">
            <p>By sharing your phone number you agree that we may call or text you about your request. Standard message and data rates may apply.</p>
          </Block>
          <Block title="Contact">
            <p>Questions about your information? Call or text us at 843-518-0021.</p>
          </Block>
        </div>
      </section>
    </>
  );
}
